import { render, staticRenderFns } from "./EditionsDetailTab.vue?vue&type=template&id=10405e76&"
import script from "./EditionsDetailTab.vue?vue&type=script&lang=js&"
export * from "./EditionsDetailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports